import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { ProcessorCloserReassignmentService } from '../processor-closer-reassignment.service';
import { ReassignmentDto, Reassignment, IgnoredProcessorCloserReassignment } from '../reassignment';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../confirm-dialog/confirm-dialog.component';
import { UwReshuffleDialogComponent } from '../../uw-reshuffle-dialog/uw-reshuffle-dialog.component';
import { UserService } from '../../users/user.service';

@Component({
    selector: 'app-pending-closer-pipeline-reassignment',
    templateUrl: './pending-closer-pipeline-reassignment.component.html',
    styleUrls: ['./pending-closer-pipeline-reassignment.component.css']
})
export class PendingCloserPipelineReassignmentComponent implements OnInit {

    @Output() pendingLoanCount = new EventEmitter<any>();

    public pendingCloserReassignmentForm: FormGroup;
    public userControl = new FormControl();
    public reassignmentMethodControl = new FormControl();
    public pendingLoanCountControl = new FormControl();
    public searchControl = new FormControl();
    public searchByControl = new FormControl();
    public isCheckedControl = new FormControl();
    public loanList = [];
    public loanCount = 0;
    public selectedLoans = [];
    public filteredLoans = [];
    public tempLoanList = [];
    public isSortedByLoan = false;
    public isSortedByMilestone = false
    public isSortedByUser = false
    public isSortedByLoanProcessor = false
    public refreshClicked: false;
    public isAllSelected = false;
    public closerUsers: any;
    public reAssign = false;
    public hasError = false;
    public unAssignedloans: string[] = [];
    public successErrorMessage: string = "";
    public inputMessage: string = "";
    public isLoading: boolean = false;
    public persona = "closer";
    public closerPendingLoans: Array<Reassignment>;
    public searchNewUser: string = null;
    public selectedClosers = [];
    public activeCloser = [];
    public assignedLoans = [];
    public selectedReassignmentLoans = [];


    public searchColumns = [
        { name: 'Loan Number', value: 'loanNumber' },
        { name: 'Last Completed Milestone', value: 'lastCompletedMilestone' },
        { name: 'Invalid Closer', value: 'user' },
        { name: 'Processor', value: 'loanProcessor' }
    ]
    constructor(
        private fb: FormBuilder,
        public processorCloserReassignmentService: ProcessorCloserReassignmentService,
        public userService: UserService,
        public dialog: MatDialog
    ) {
        this.createForm();
    }

    async ngOnInit() {

        await this.getPendingLoans();
        await this.userService.getUsersByPersona('Sr Closer').then(
            result => {
                if (result != null && result != undefined && result.length > 0) {
                    this.closerUsers = JSON.parse(JSON.stringify(result));
                    this.closerUsers.sort((a, b) => (a.firstName + ' ' + a.lastName).localeCompare(b.firstName + ' ' + b.lastName));
                    this.activeCloser = JSON.parse(JSON.stringify(this.closerUsers));
                }
            }
        )
            .catch(error => {
                console.log(error)
                this.isLoading = false;
            });

    }

    createForm() {
        this.isAllSelected = false;
        this.selectedLoans = [];
        this.filteredLoans = [];
        this.tempLoanList = [];

        this.pendingCloserReassignmentForm = this.fb.group({
            searchLoan: this.fb.group({
                searchControl: [null],
                searchByControl: [null]
            }),
            pendingLoanCountControl: [null],
            isCheckedControl: [null],
            userControl: [null, Validators.required]
        });
    }

    async getPendingLoans() {
        this.isLoading = true;
        this.inputMessage = "Fetching pending loans, please wait...";
        this.successErrorMessage = "";

        await this.processorCloserReassignmentService.getCloserPendingLoans().then(
            loans => {
                if (loans != null && loans != undefined) {
                    if (loans.length > 0) {
                        this.loanList = JSON.parse(JSON.stringify(loans));
                        this.loanList.forEach(loan => {
                            loan.isChecked = false;
                        })
                        this.inputMessage = "";
                    }
                    this.loanCount = this.loanList.length;
                }
                this.pendingLoanCount.emit(this.loanCount);
                this.isLoading = false;
            })
            .catch(error => {
                console.log(error)
                this.isLoading = false;
            });

    }

    reassign() {
        if (!this.pendingCloserReassignmentForm.get("userControl").valid || this.loanList.length <= 0 || this.selectedLoans.length <= 0) {
            this.hasError = true;
            return;
        }

        if (this.tempLoanList.length > 0) {
            this.loanList = JSON.parse(JSON.stringify(this.tempLoanList));
        }
        this.hasError = false;
        this.inputMessage = "Reassignment in progress, please wait...";
        this.successErrorMessage = "";
        this.isLoading = true;
        this.selectedReassignmentLoans = JSON.parse(JSON.stringify(this.selectedLoans));
        this.makePendingLoanReassignment(0);
    }

    createReassignmentDto(loanIndex) {
        var reassignment: ReassignmentDto = new ReassignmentDto();
        reassignment.loan = this.selectedReassignmentLoans[loanIndex];
        reassignment.users = this.selectedClosers;
        return reassignment;
    }

    async makePendingLoanReassignment(index) {
        var reassignment = this.createReassignmentDto(index);
        this.processorCloserReassignmentService.makePendingCloserReassignment(reassignment).then(data => {
            if (!data.assignedSuccessfully) {
                this.unAssignedloans.push(reassignment.loan.loanNumber);
            }
            else {
                this.assignedLoans.push(data.messages[0]);
                var loanIndex = this.loanList.findIndex(element => {
                    return (element.loanNumber == reassignment.loan.loanNumber);
                });
                this.loanList.splice(loanIndex, 1);
                this.loanCount = this.loanList.length;
                this.pendingLoanCount.emit(this.loanCount);
                this.selectedLoans.splice(index, 1);
            }
            index++;
            if (this.selectedReassignmentLoans.length > index) {
                this.makePendingLoanReassignment(index);
            }
            else {
                this.isLoading = false;
                this.inputMessage = "";
                this.showMessage()

            }
        })
            .catch(error => {
                console.log(error);
                this.isLoading = false;
                this.inputMessage = "";
                this.unAssignedloans.push(reassignment.loan.loanNumber);
            });
    }


    confirmDelete(loan: any) {
        const message = "Are you sure you want to ignore this loan from reassignment ?";
        const dialogData = new ConfirmDialogModel("Confirm Action", message);

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: dialogData
        });

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (dialogResult) {
                this.deleteLoan(loan);
            }
        });
    }

    async deleteLoan(loan) {
        var ignoredProcessorCloserReassignment = new IgnoredProcessorCloserReassignment();
        ignoredProcessorCloserReassignment.loanNumber = loan.loanNumber;
        ignoredProcessorCloserReassignment.personaId = loan.personaId;

        this.processorCloserReassignmentService.deletePendingLoan(ignoredProcessorCloserReassignment).then(
            deleted => {
                if (deleted) {
                    var loanIndex = this.loanList.findIndex(element => {
                        return (element.loanNumber == loan.loanNumber);
                    });
                    this.loanList.splice(loanIndex, 1);
                    this.loanCount = this.loanList.length;

                    var selectedLoanIndex = this.selectedLoans.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                    if (selectedLoanIndex != -1) {
                        this.selectedLoans.splice(selectedLoanIndex, 1);
                    }
                    if (this.tempLoanList.length > 0) {
                        var tempLoanListIndex = this.tempLoanList.findIndex(element => { return (element.loanNumber = loan.loanNumber); });
                        if (tempLoanListIndex != -1) {
                            this.tempLoanList.splice(tempLoanListIndex, 1);
                            this.loanCount = this.tempLoanList.length;
                        }
                    }
                    this.pendingLoanCount.emit(this.loanCount);
                }
            });
    }

    async showMessage() {
        var message = "Assignment Closer is complete. See below for a list of loans that did get assigned and those that did not."
        var dialogData = [{ "message": message, "LoanList": this.unAssignedloans, "AssignedLoanList": this.assignedLoans }];

        this.dialog.open(UwReshuffleDialogComponent, {
            width: "400px", height: "auto",
            data: dialogData,
        });
        this.finalizeReassignment();
    }

    finalizeReassignment() {
        this.pendingCloserReassignmentForm.get("isCheckedControl").setValue(false);
        this.isAllSelected = false;
        this.selectedReassignmentLoans = [];
        this.assignedLoans = [];
        this.unAssignedloans = [];
        this.filteredLoans = [];
        this.tempLoanList = [];
        var searchLoanFormGroup = this.pendingCloserReassignmentForm.controls.searchLoan;
        searchLoanFormGroup.get("searchByControl").setValue("");
        searchLoanFormGroup.get("searchControl").setValue("");
        if (this.isSame()) {
            this.pendingCloserReassignmentForm.get("isCheckedControl").setValue(true);
            this.isAllSelected = true;
        }
    }

    selectLoan(loan: any) {

        if (this.selectedLoans.length != 0) {
            var loanIndex = this.selectedLoans.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
            if (loanIndex != -1) {
                this.selectedLoans.splice(loanIndex, 1);
                var index = this.loanList.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                this.loanList[index].isChecked = false;
            }
            else {
                this.selectedLoans.push(loan);
                var index = this.loanList.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                this.loanList[index].isChecked = true;
            }
        }
        else {
            this.selectedLoans.push(loan);
            this.selectedLoans.forEach(loan => {
                var index = this.loanList.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                if (index != null && index != -1) {
                    this.loanList[index].isChecked = true;
                }
            });
        }

        if (this.isSame()) {

            this.pendingCloserReassignmentForm.get("isCheckedControl").setValue(true);
            this.isAllSelected = true;

        }
        else {
            this.pendingCloserReassignmentForm.get("isCheckedControl").setValue(false);
            this.isAllSelected = false;

        }
    }

    sortByLoan() {
        if (!this.isSortedByLoan) {
            this.isSortedByLoan = true;
            this.isSortedByMilestone = false
            this.isSortedByUser = false;
            this.isSortedByLoanProcessor = false;
            this.loanList.sort((a, b) => a.loanNumber.localeCompare(b.loanNumber));
        } else {
            this.isSortedByLoan = false;
            this.loanList.sort((a, b) => a.loanNumber.localeCompare(b.loanNumber)).reverse();
        }

    }

    sortByMilestone() {
        if (!this.isSortedByMilestone) {
            this.isSortedByMilestone = true;
            this.isSortedByUser = false;
            this.isSortedByLoanProcessor = false;
            this.isSortedByLoan = false;
            this.loanList.sort((a, b) => a.lastCompletedMilestone.localeCompare(b.lastCompletedMilestone));
        } else {
            this.isSortedByMilestone = false
            this.loanList.sort((a, b) => a.lastCompletedMilestone.localeCompare(b.lastCompletedMilestone)).reverse();
        }

    }

    sortByUser() {
        if (!this.isSortedByUser) {
            this.isSortedByUser = true;
            this.isSortedByLoan = false;
            this.loanList.sort((a, b) => a.firstName.localeCompare(b.firstName));
        } else {
            this.isSortedByUser = false;
            this.loanList.sort((a, b) => a.firstName.localeCompare(b.firstName)).reverse();
        }
    }

    sortByLoanProcessor() {
        if (!this.isSortedByLoanProcessor) {
            this.isSortedByLoanProcessor = true;
            this.isSortedByLoan = false;
            this.loanList.sort((a, b) => a.loanProcessor.localeCompare(b.loanProcessor));
        } else {
            this.isSortedByLoanProcessor = false;
            this.loanList.sort((a, b) => a.loanProcessor.localeCompare(b.loanProcessor)).reverse();
        }
    }

    searchTable() {
        this.pendingCloserReassignmentForm.get("isCheckedControl").setValue(false);
        this.isAllSelected = false;

        if (this.tempLoanList.length > 0) {
            this.loanList = JSON.parse(JSON.stringify(this.tempLoanList));
            this.filteredLoans.length = 0;
        }
        var searchLoanFormGroup = this.pendingCloserReassignmentForm.controls.searchLoan;
        var searchByControl = searchLoanFormGroup.get("searchByControl").value;
        var searchControl = searchLoanFormGroup.get("searchControl").value;
        if (this.filteredLoans.length == 0) {
            if (searchByControl == null || searchControl == null) {
                return;
            }
            if (searchByControl == 'user') {
                this.filteredLoans = this.loanList.filter(element =>
                    (element['firstName'] + ' ' + element['lastName']).toUpperCase().includes(searchControl.toUpperCase())
                );
            }
            else if (searchByControl == 'loanProcessor') {
                this.filteredLoans = this.loanList.filter(element =>
                    element['loanProcessor'].toUpperCase().includes(searchControl.toUpperCase())
                );
            }
            else if (searchByControl == 'loanNumber') {
                this.filteredLoans = this.loanList.filter(element =>
                    element[searchByControl].toUpperCase().includes(searchControl.toUpperCase())
                );
            }
            else {
                this.filteredLoans = this.loanList.filter(element =>
                    element[searchByControl].toUpperCase().includes(searchControl.toUpperCase())
                );
            }
            this.tempLoanList = JSON.parse(JSON.stringify(this.loanList));
            this.loanList = [];
            this.loanList = JSON.parse(JSON.stringify(this.filteredLoans));
            var isListSame = this.isSame();
            if (isListSame) {
                this.pendingCloserReassignmentForm.get("isCheckedControl").setValue(true);
                this.isAllSelected = true;
            }
        }

    }

    isSame() {
        var count = 0;
        var result = false;
        if (this.loanList.length > 0) {
            this.selectedLoans.forEach(element => {
                var loan = this.loanList.filter(item =>
                    !item.loanNumber.localeCompare(element.loanNumber)
                );
                if (loan.length > 0) {
                    count++;
                }
            });
            if (this.loanList.length === count) {
                result = true;
            }
        }
        return result;

    }

    refresh() {

        var searchLoanFormGroup = this.pendingCloserReassignmentForm.controls.searchLoan;
        searchLoanFormGroup.get("searchByControl").setValue("");
        searchLoanFormGroup.get("searchControl").setValue("");
        this.pendingCloserReassignmentForm.get("isCheckedControl").setValue(false);
        this.isAllSelected = false;
        if (this.tempLoanList.length > 0) {
            this.loanList = [];
            this.loanList = JSON.parse(JSON.stringify(this.tempLoanList));
            this.tempLoanList = [];
            this.filteredLoans = [];
            if (this.selectedLoans.length != 0) {
                this.selectedLoans.forEach(loan => {
                    var index = this.loanList.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                    this.loanList[index].isChecked = true;
                });
            }
        }
        if (this.isSame()) {
            this.pendingCloserReassignmentForm.get("isCheckedControl").setValue(true);
            this.isAllSelected = true;
        }

    }

    selectAll() {

        if (this.loanList.length > 0) {
            if (this.isAllSelected == false) {

                this.loanList.forEach(loan => {
                    loan.isChecked = true;
                    var index = this.selectedLoans.findIndex(element => element === loan);
                    if (index === -1) {
                        this.selectedLoans.push(loan)
                    }
                });
                this.isAllSelected = true;
            }
            else {
                this.loanList.forEach(loan => {
                    loan.isChecked = false;
                    if (this.tempLoanList.length > 0) {
                        this.tempLoanList.forEach(element => {
                            if (element.loanNumber === loan.loanNumber) {
                                element.isChecked = false;
                            }
                        })
                    }
                });
                this.isAllSelected = false;
                this.selectedLoans = [];
            }
        }
    }

    onSearchChange() {
        if (this.searchNewUser) {
            this.activeCloser = this.closerUsers.filter(value => value.name.toLowerCase().includes(this.searchNewUser.toLowerCase()));
            this.selectedClosers.forEach(value => {
                if (!this.activeCloser.includes(value)) {
                    this.activeCloser.push(value)
                }
            });
        }
        else {
            this.activeCloser = this.closerUsers;
        }
    }

    onSelectionChange(event) {
        if (event.value.length > 0) {
            event.value.forEach(val => {
                if (!this.selectedClosers.includes(val)) {
                    this.selectedClosers.push(val);
                }
            })
            let tempUsers = [...this.selectedClosers];
            tempUsers.forEach((val, index) => {
                if (!event.value.includes(val)) {
                    this.selectedClosers.splice(index, 1);
                }
            })
        }
        else {
            this.selectedClosers = [];
            this.reAssign = false;
        }

        if (this.selectedClosers.length > 0) {
            this.reAssign = true;
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/processor-closer-pipeline-reassignment/pending-closer-pipeline-reassignment/pending-closer-pipeline-reassignment.component.ts